/**
 * TosBlock — the "Terms of Service" section. Extracted from Landing.jsx so
 * both the homepage and the standalone /tos page can render it identically.
 */
import { ShieldAlert } from "lucide-react";

export default function TosBlock({ tos = [] }) {
  return (
    <section
      id="tos"
      data-testid="tos-section"
      className="relative py-24 md:py-32 px-6 md:px-10 bg-black/60 backdrop-blur-sm border-y border-[var(--accent-dim)]"
    >
      <div className="max-w-5xl mx-auto">
        <div className="mb-12 grid md:grid-cols-[1fr_auto] gap-8 items-end">
          <div>
            <div className="bracket mb-4 flex items-center gap-3">
              <span className="num-solid text-[10px]">/04</span>
              TERMS_OF_SERVICE
            </div>
            <h2
              className="font-display text-5xl md:text-6xl lg:text-7xl font-extrabold uppercase tracking-[-0.03em] leading-[0.9]"
            >
              READ<br />
              <span className="text-[var(--accent)] text-glow">CAREFULLY.</span>
            </h2>
          </div>
          <ShieldAlert className="text-[var(--accent)] hidden md:block" size={64} strokeWidth={1.5} />
        </div>

        <div className="border border-[var(--theme-border)] bg-[var(--theme-surface)]/70 backdrop-blur-sm rounded-2xl overflow-hidden">
          <div className="border-b border-[var(--theme-border)] px-5 py-3 flex items-center gap-3 bg-[var(--accent)]/5">
            <span className="w-2 h-2 bg-red-500 rounded-full" />
            <span className="w-2 h-2 bg-[var(--accent)] rounded-full" />
            <span className="w-2 h-2 bg-[var(--muted)] rounded-full" />
            <span className="font-mono text-[10px] tracking-widest uppercase text-[var(--muted)] ml-4">
              tos.txt — null_mods // legal
            </span>
          </div>
          <div className="p-6 md:p-10 font-mono text-sm leading-relaxed">
            {tos.map((t, i) => (
              <div key={i} className="mb-5 last:mb-0">
                <span className="text-[var(--accent)] mr-3">[{String(i + 1).padStart(2, "0")}]</span>
                <span className="text-[var(--muted)] mr-2">$</span>
                <span className="text-white">{t}</span>
              </div>
            ))}
            <div className="mt-6 text-[var(--accent)] cursor-blink">$ EOF</div>
          </div>
        </div>
      </div>
    </section>
  );
}
